exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".desc[data-v-5ac595ee]{color:#999;font-size:12px;line-height:16px;margin:0}[data-v-5ac595ee].el-input__suffix{right:10px;line-height:32px}.selWidth[data-v-5ac595ee]{width:460px !important}", ""]);

// exports
